<script lang="ts" runes>
    import { Dialog } from "@/components";
    import { CalooAdminConfig } from "@/services/admin";
    import {
        getHealthConnectFromStore,
        launchPrivacyPolicy,
        openHealthSettings,
    } from "@/services/health";
    import { translate } from "@/utils/format";
    import { goTo } from "@/utils/router";

    let { sections } = $props();

    let showConfirm = $state(false);
    let pendingLink = "";
    let confirmMessage = $state({
        message: "",
        buttonOk: translate("OK", "Ok"),
        buttonCancel: translate("Cancel", "Cancel"),
    });

    const actionsMap = {
        getHealthConnectFromStore,
        launchPrivacyPolicy,
        openHealthSettings,
        runQuestionaireAgain() {
            console.log("Running questionaire again");
            const questionaireId =
                CalooAdminConfig.nijiConfiguration?.initWizard ||
                import.meta.env.VITE_WIZARD_BACKGROUND_ID;
            goTo(`/wizard/${questionaireId}?repeat=true`, { repeat: true });
        },
    };

    function handleClick(item) {
        if (item.confirm) {
            pendingLink = item.link;
            confirmMessage = {
                message: item.confirmMessage?.message || "Are you sure?",
                buttonOk: item.confirmMessage?.buttonOk || "Ok",
                buttonCancel: item.confirmMessage?.buttonCancel || "Cancel",
            };
            showConfirm = true;
        } else if (item.action && actionsMap[item.action]) {
            actionsMap[item.action](); // ejecuta la acción si existe
        } else if (item.link) {
            goTo(item.link);
        }
    }

    function confirmOk() {
        goTo(pendingLink);
        resetConfirm();
    }

    function confirmCancel() {
        resetConfirm();
    }

    function resetConfirm() {
        showConfirm = false;
        pendingLink = "";
        confirmMessage = {
            message: "",
        };
    }
</script>

<div class="menu">
    {#each sections as section}
        <ul class="menu__section">
            {#each section.items as item, index}
                <li class="menu__item">
                    <a
                        href="javascript:void(0)"
                        class={section.items.length === index + 1
                            ? "--last"
                            : ""}
                        on:click={() => handleClick(item)}
                    >
                        <i
                            class="menu__icon fal fa-{item.icon}"
                            style="color: {item.color}"
                        ></i>
                        <p>{item.text}</p>
                    </a>
                </li>
            {/each}
        </ul>
    {/each}
</div>

{#if showConfirm}
    <Dialog
        isOpen={showConfirm}
        message={confirmMessage.message}
        labelOk={confirmMessage.buttonOk || "Ok"}
        labelCancel={confirmMessage.buttonCancel || "Cancel"}
        onOk={confirmOk}
        onCancel={confirmCancel}
    />
{/if}

<style lang="scss">
    @use "./styles/index.scss";
</style>
